import { render } from "./CustomerBottomNavigation.vue?vue&type=template&id=68c32e20&scoped=true&ts=true&lang=pug"
import script from "./CustomerBottomNavigation.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomerBottomNavigation.vue?vue&type=script&lang=ts&setup=true"

import "./CustomerBottomNavigation.vue?vue&type=style&index=0&id=68c32e20&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68c32e20"]])

export default __exports__